import React from 'react';
import { UI, QUESTION_KEY_PREVIEW_LENGTH } from '@/lib/constants';

const LIKERT_LABELS = [
  { value: 1, label: 'Strongly Disagree' },
  { value: 2, label: 'Disagree' },
  { value: 3, label: 'Neutral' },
  { value: 4, label: 'Agree' },
  { value: 5, label: 'Strongly Agree' },
];

const LikertOptionCard = ({ option, selected, onSelect, testId }) => {
  const base = 'group flex-1 min-w-0 px-2 py-3 sm:py-4 rounded-xl border-2 cursor-pointer transition-all duration-200 select-none flex flex-col items-center justify-center gap-1';
  const stateClasses = selected
    ? 'bg-teal-600 border-teal-600 text-white shadow-lg shadow-teal-600/25 scale-[1.03]'
    : 'bg-white border-slate-200 text-slate-600 hover:border-teal-500 hover:shadow-md hover:-translate-y-0.5';
  return (
    <button
      type="button"
      onClick={onSelect}
      className={`${base} ${stateClasses}`}
      data-testid={testId}
      aria-pressed={selected}
    >
      <span className={`text-lg font-bold ${selected ? 'text-white' : 'text-slate-900'}`}>
        {option.value}
      </span>
      <span className={`text-[10px] sm:text-xs font-medium text-center leading-tight ${selected ? 'text-white' : 'text-slate-500 group-hover:text-slate-700'}`}>
        {option.label}
      </span>
    </button>
  );
};

const LikertQuestion = ({ question, value, onChange, testIdPrefix, domain }) => {
  const stableKey = `${domain}-${question.substring(0, QUESTION_KEY_PREVIEW_LENGTH)}`;
  return (
    <div
      key={stableKey}
      className="bg-white border border-slate-100 rounded-2xl p-5 sm:p-6 mb-4 shadow-sm hover:shadow-md transition-shadow"
    >
      <p className="text-slate-900 font-semibold leading-snug mb-4 text-[15px] sm:text-base">
        {question}
      </p>
      <div className="flex gap-2 sm:gap-3">
        {LIKERT_LABELS.map((opt) => (
          <LikertOptionCard
            key={opt.value}
            option={opt}
            selected={value === opt.value}
            onSelect={() => onChange(opt.value)}
            testId={`${testIdPrefix}-option-${opt.value}`}
          />
        ))}
      </div>
    </div>
  );
};

// Keep the named UI export in case other files consume it (unused now but stable).
export { UI };
export default React.memo(LikertQuestion);
